import { render, staticRenderFns } from "./ImageCarouselOverlay.vue?vue&type=template&id=31e06e1a&scoped=true&"
import script from "./ImageCarouselOverlay.vue?vue&type=script&lang=js&"
export * from "./ImageCarouselOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ImageCarouselOverlay.vue?vue&type=style&index=0&id=31e06e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e06e1a",
  null
  
)

export default component.exports